
import 'lity';
import SwiperCtrl from './vendor/_swiper';
import ScrollMagicCtrl from './vendor/_scrollmagic';
import SliderProCtrl from './vendor/_sliderpro';

new SwiperCtrl()
new SliderProCtrl()
new ScrollMagicCtrl()

import CommonCtrl from './inc/_common';
import FAQ_Ctrl from './inc/_faq';

new CommonCtrl()
new FAQ_Ctrl()

import ApplicationSubmit from './application/_submit';
import KaijouCtrl from './application/_kaijou';

var submit = new ApplicationSubmit();
var kaijou = new KaijouCtrl();

import './inc/_news';
import './inc/_seminar';
import './inc/_recommend';

// import './src/_audio';


